export default __webpack_public_path__ + "fc2891db49b5939d5246a288bab6c4b1.png";